export default "__VITE_ASSET__BLhdP_yL__";